import { render, staticRenderFns } from "./authorization-page.vue?vue&type=template&id=5892f6f8&scoped=true&"
import script from "./authorization-page.vue?vue&type=script&lang=js&"
export * from "./authorization-page.vue?vue&type=script&lang=js&"
import style0 from "./authorization-page.vue?vue&type=style&index=0&id=5892f6f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892f6f8",
  null
  
)

export default component.exports